
import homePages from '../Images/aboutus.png';

export default function AboutUs() {
  return (
    <div className="aboutus">
      <h3>WHY PLUS CREDIT?</h3>
      <img src={homePages} alt="hero" className="affilatehero" />

      <h4 className="h4">Why Ride With Us?</h4>
      <ul>
        <li>Partner-Powered – We work with the best to bring you trusted, flexible products.</li>
        <li>Fully Digital – No paperwork. No long queues. Just quick, clean access.</li>
        <li>Built for Life – Whether you’re investing, buying, or traveling, we’ve got a product for you.</li>
        <li>Affiliate Friendly – Help others. Make money. Repeat.</li>
      </ul>

      <div className="statements">
        <div className="vision">
          <h3>VISION STATEMENT</h3>
          <p>
            To become the most trusted platform for everyday Africans to access seamless, digital-first
            financial tools that empower real-life progress.
          </p>
        </div>

        <div className="mission">
          <h3>MISSION STATEMENT</h3>
          <p>
            At PlusCredit, our mission is to simplify financial access for all by delivering smart, secure,
            and flexible financial products from credit and savings to installment plans and investment
            opportunities through digital platforms and a growing community of trusted affiliates.
          </p>
        </div>
      </div>

      <div>
        <h3>CORE VALUES</h3>
        <div className="grid">
          <div className="core-value">
            <h4>Customer-Centricity</h4>
            <p>
              We put people first our products and processes are built to genuinely solve customer needs.
            </p>
          </div>

          <div className="core-value">
            <h4>Partnership</h4>
            <p>
              We collaborate with trusted brands to co-create relevant and impactful financial solutions.
            </p>
          </div>

          <div className="core-value">
            <h4>Accessibility</h4>
            <p>
              We make finance simpler, faster, and available to everyone — no long queues, no stress.
            </p>
          </div>

          <div className="core-value">
            <h4>Integrity</h4>
            <p>
              We build trust through transparency, honesty, and always doing right by our users.
            </p>
          </div>

          <div className="core-value">
            <h4>Innovation</h4>
            <p>
              We embrace digital-first systems to stay ahead and deliver smarter, future-proof services.
            </p>
          </div>

          <div className="core-value">
            <h4>Community</h4>
            <p>
              From affiliates to customers, we grow together by sharing value and supporting each other.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
